import { Component,ViewChild } from '@angular/core';
import { Chart, ChartConfiguration, ChartEvent, ChartType } from 'chart.js';
import { BaseChartDirective } from 'ng2-charts';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
import { getLocalJSON } from '../../_helpers/storage.util';
import { transactionStatusLabel, transactionTitle, transactionTypeLabel } from '../../_helpers/payments.util';
declare var $:any;

@Component({
  selector: 'app-financials',
  templateUrl: './financials.component.html',
  styleUrls: ['./financials.component.scss']
})
export class FinancialsComponent {

  public statusLabel = transactionStatusLabel;
  public typeLabel = transactionTypeLabel;
  public titleLabel = transactionTitle;

  public loading:boolean = true;
  public PurchaseList:any=[];
  public TransactionList:any=[];

  public totalCount: number = 0;
  public p = 1;
  public pageLimit = 10;
  public types:any='revenue';
  public filters:any='month'
  private newLabel? = 'New label';
  public previousLabel:any='';
  public nextLabel:any='';
  public chartShow:boolean=false;
  public donutShow:boolean=false;
  public loginDetail:any =[];
  public viewshows:boolean=false;
  public coll_val:any= '';
  public can_val:any='';
  public pro_val:any='';
  public subs_val:any='';
  public ref_val:any='';
  public pre_amt:any='';
  public cur_amt:any='';
  public var_amt:any='';
  public var_per:any='';
  public var_typ:any='';

  public doughnutChartPlugins: any=[];
  public barChartLegend = true;
  public barChartPlugins :any= [];
  public doughnutChartData: any = {
    type: 'doughnut',
    labels: [ ],
    datasets: [
      { data: [] },{ data: [] },{ data: [] }, { data: [] }
    ],   
  };
  public data:any = [];
  
  public centerText: String = "Center Text";
  public chartOptions: any & { annotation: any }= {
    centerText: this.centerText
  };

  public barChartData:any = {
    type: 'line',
    labels: [  ],
    datasets: [
      { data: [ ]},
      { data: [  ]},
      { data: [  ] },
      { data: [] }
    ]
  };
  
  public barChartOptions: ChartConfiguration['options'] = {
    scales: {
      y:
        {
          position: 'left',
        },
    },

    plugins: {
      legend: { display: true },
     
    }
  };

  public lineChartData: any = {  
    type: 'line',  
    labels: [  ],
    datasets: [{ data: [] } , { data: [] } , { data: [] }, { data: [] }],
  };
 
  public lineChartOptions: ChartConfiguration['options'] = {
    scales: {
      y:
        {
          position: 'left',
        },
    },

    plugins: {
      legend: { display: true },
    }
  };


  @ViewChild(BaseChartDirective) chart?: BaseChartDirective;

  private static generateNumber(i: number): number {
    return Math.floor((Math.random() * (i < 2 ? 100 : 1000)) + 1);
  }

  public randomize(): void {
    for (let i = 0; i < this.lineChartData.datasets.length; i++) {
      for (let j = 0; j < this.lineChartData.datasets[i].data.length; j++) {
        this.lineChartData.datasets[i].data[j] = FinancialsComponent.generateNumber(i);
      }
    }
    this.chart?.update();
  }

  // events
  public chartClicked({ event, active }: { event?: ChartEvent, active?: {}[] }): void {
  }

  public chartHovered({ event, active }: { event?: ChartEvent, active?: {}[] }): void {
  }

  public hideOne(): void {
    const isHidden = this.chart?.isDatasetHidden(1);
    this.chart?.hideDataset(1, !isHidden);
  }

  public pushOne(): void {
    this.lineChartData.datasets.forEach((x:any, i:any) => {
      const num = FinancialsComponent.generateNumber(i);
      x.data.push(num);
    });
    this.lineChartData?.labels?.push(`Label ${ this.lineChartData.labels.length }`);

    this.chart?.update();
  }

  public changeColor(): void {
    this.lineChartData.datasets[3].borderColor = 'green';
    this.lineChartData.datasets[3].backgroundColor = `rgba(0, 255, 0, 0.3)`;

    this.chart?.update();
  }

  public changeLabel(): void {
    const tmp = this.newLabel;
    this.newLabel = this.lineChartData.datasets[2].label;
    this.lineChartData.datasets[2].label = tmp;

    this.chart?.update();
  }



  constructor(public router: Router, public service: GlobalService) { 
    this.loginDetail = getLocalJSON('grw_login');
    this.getPurchase();
   }

   ngOnInit(): void {
  }

  getPurchase(){
    this.chartShow=false;
    this.barChartData.labels= [ ];
    this.lineChartData.labels= [ ];
    this.doughnutChartData.labels=[];
    this.lineChartData.datasets= [ { data: [] } , { data: [] } , { data: [] }, { data: [] } , { data: [] }];
    this.barChartData.datasets= [ { data: [] } , { data: [] } , { data: [] }, { data: [] } , { data: [] }];
    this.doughnutChartData.datasets=[{ data: [] }];
    this.loading=true;
      if(this.filters=='week'){
        $('#week').addClass(' active') ;  
        $('#year').removeClass(' active') ;  
        $('#month').removeClass(' active') ;    
      } if (this.filters=='month'){
        $('#month').addClass(' active') ;  
        $('#week').removeClass(' active') ;  
        $('#year').removeClass(' active') ;    
      } if (this.filters=='year') {
        $('#year').addClass(' active') ;  
        $('#week').removeClass(' active') ;  
        $('#month').removeClass(' active') ;    
      }
    var url= "/financials?type="+this.filters +'&section='+this.types;
    this.service.GetApi(url).subscribe(((response:any)=>{
      if(response.success ==1) {
        var self =this;
        response.data.recent_sale.filter((el:any)=>{
          el.amounts= parseFloat(el.txnAmout).toFixed(2)  ; 
        })
        //   response.data.txnList.filter((el:any)=>{
        //   el.amounts= parseFloat(el.txnAmout).toFixed(2)  ; 
        // })
        this.totalCount = response.data.total;
        // this.PurchaseList = response.data.recent_sale;
        // this.TransactionList=response.data.txnList;
        this.getData('');
        if(response.data.breakdown !=''){
         self.pre_amt=self.loginDetail.userCurrencySymbol+' '  +parseFloat(response.data.breakdown.CurrentPayCycle).toFixed(2);

// "positive"
         self.cur_amt=self.loginDetail.userCurrencySymbol+' '  +parseFloat(response.data.breakdown.PerviousPayCycle).toFixed(2);
         self.var_amt=self.loginDetail.userCurrencySymbol+' '  +parseFloat(response.data.breakdown.Variance).toFixed(2);
         self.var_per=response.data.breakdown.VariancePercentage +'%';
         self.var_typ=response.data.breakdown.VarianceType;
        }
        if(response.data.collection.programs.length !=0){
          response.data.collection.programs.filter((el:any)=>{
            self.barChartData.labels.push(el.id);
            self.barChartData.datasets[0].data.push(el.value);
            self.lineChartData.labels.push(el.id);
            self.lineChartData.datasets[0].data.push(el.value);
          })
        }
        if(response.data.collection.cancellations.length !=0){
          response.data.collection.cancellations.filter((el:any)=>{
            if(self.lineChartData.labels.length ==0){
              self.lineChartData.labels.push(el.id);
              self.barChartData.labels.push(el.id);
            }
            self.lineChartData.datasets[1].data.push(el.value);
            self.barChartData.datasets[1].data.push(el.value);
          })
        }
        if(response.data.collection.subscriptions.length !=0){
          response.data.collection.subscriptions.filter((el:any)=>{
            if(self.lineChartData.labels.length ==0){
              self.lineChartData.labels.push(el.id);
              self.barChartData.labels.push(el.id);
            }
            self.lineChartData.datasets[2].data.push(el.value);
            self.barChartData.datasets[2].data.push(el.value);
          })
        }
        if(response.data.collection.referrals.length !=0){
          response.data.collection.referrals.filter((el:any)=>{
            if(self.lineChartData.labels.length ==0){
              self.lineChartData.labels.push(el.id);
              self.barChartData.labels.push(el.id);
            }
            self.lineChartData.datasets[3].data.push(el.value);
            self.barChartData.datasets[3].data.push(el.value);
          })
        }
        if(response.data.collection.referrals.length !=0){
          response.data.collection.referrals.filter((el:any)=>{
            if(self.lineChartData.labels.length ==0){
              self.lineChartData.labels.push(el.id);
              self.barChartData.labels.push(el.id);
            }
            self.lineChartData.datasets[4].data.push(el.value);
            self.barChartData.datasets[4].data.push(el.value);
          })
        }
        self.lineChartData.datasets[0].label='Programs'; 
        self.lineChartData.datasets[1].label= 'Cancellations';
        self.lineChartData.datasets[2].label= 'Subscriptions';
        self.lineChartData.datasets[3].label= 'Referrals';
        self.lineChartData.datasets[4].label= 'Collaborations';

        self.barChartData.datasets[0].label='Programs'; 
        self.barChartData.datasets[1].label= 'Cancellations';
        self.barChartData.datasets[2].label= 'Subscriptions';
        self.barChartData.datasets[3].label= 'Referrals';
        self.barChartData.datasets[4].label= 'Collaborations';

        if(response.data.financial.length != 0){
          var ssd:any=0;
          response.data.financial.filter((el:any)=>{        
            var ss:any =el.x +' ' +self.loginDetail.userCurrencySymbol + el.y;
            ssd=ssd+el.y;
            if(el.x=='Referrals'){
              self.ref_val=self.loginDetail.userCurrencySymbol+' '  + parseFloat(el.y).toFixed(2);
            } 
            if(el.x=='Subscription'){
              self.subs_val=self.loginDetail.userCurrencySymbol+' '  + parseFloat(el.y).toFixed(2);
            } 
            if(el.x=='Programs'){
              self.pro_val=self.loginDetail.userCurrencySymbol+' '  + parseFloat(el.y).toFixed(2);
            } 
            if(el.x=='Cancellations'){
              self.can_val=self.loginDetail.userCurrencySymbol+' '  + parseFloat(el.y).toFixed(2);
            } 
            if(el.x=='Collaborations'){
              self.coll_val=self.loginDetail.userCurrencySymbol+' '  + parseFloat(el.y).toFixed(2);
            } 
            // self.doughnutChartData.labels.push(ss);
            self.doughnutChartData.datasets[0].data.push(el.y);
          })
          response.data.totalPurchasedAmount =ssd;
          self.doughnutChartPlugins = [{
            beforeDraw(chart:any) {
              const ctx = chart.ctx;
              const txt = 'Center Text';        
              //Get options from the center object in options
              const sidePadding = 60;
              const sidePaddingCalculated = (sidePadding / 100) * (chart.innerRadius * 2)
        
              ctx.textAlign = 'center';
              ctx.textBaseline = 'middle';
              const centerX = ((chart.chartArea.left + chart.chartArea.right) / 2);
              const centerY = ((chart.chartArea.top + chart.chartArea.bottom) / 2);
        
              //Get the width of the string and also the width of the element minus 10 to give it 5px side padding
              const stringWidth = ctx.measureText(txt).width;
              const elementWidth = (chart.innerRadius * 2) - sidePaddingCalculated;
        
              // Find out how much the font can grow in width.
              const widthRatio = elementWidth / stringWidth;
              const newFontSize = Math.floor(30 * widthRatio);
              const elementHeight = (chart.innerRadius * 2);
        
              // Pick a new font size so it will not be larger than the height of label.
              const fontSizeToUse = Math.min(newFontSize, elementHeight);
              ctx.font = 13 + 'px Arial Black';
              ctx.fillStyle = '#ffffff';
        
              // Draw text in center
              var ss='Total :'+ self.loginDetail.userCurrencySymbol  + parseFloat(response.data.totalPurchasedAmount).toFixed(2);
              ctx.fillText(ss, centerX, centerY);
            }
          }];
        }
        if(response.data.totalPurchasedAmount !=0 || response.data.referralCount !=0){
          this.donutShow=true; 
        } 
       this.chartShow=true;
       this.loading= false; 
      } else {
        this.loading=false;
      }
    }), (error) => { this.loading =false; });
  }

  getData(data:any){
    var url ='';
    if(data !=''){
      data= this.service.ToDate(data.value);
      url = "/transactions?tran_date="+data; 
    } else {
      url = "/transactions"; 
    }
    this.service.GetApi(url).subscribe(((response:any)=>{
      if(response.success ==1) {
        var self =this;
        response.data.data.filter((el:any)=>{
          el.amounts= parseFloat(el.txnAmout).toFixed(2)  ;     
        })
        this.totalCount = response.data.total;
        this.PurchaseList = response.data.data;
        this.TransactionList = response.data.data;

      } else {
        this.TransactionList = [];
        this.PurchaseList = [];
      }
    }), (error) => { this.loading =false; });
  }
}
